import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

// Set visual viewport height CSS variable for mobile keyboard handling
if (window.visualViewport) {
  const setViewportHeight = () => {
    document.documentElement.style.setProperty('--vh', `${window.visualViewport.height}px`);
  };
  
  // Set initial value
  setViewportHeight();
  
  // Update on resize (handles keyboard open/close on mobile)
  window.visualViewport.addEventListener('resize', setViewportHeight);
} else {
  // Fallback for browsers without visualViewport support
  const setViewportHeight = () => {
    document.documentElement.style.setProperty('--vh', `${window.innerHeight}px`);
  };
  
  setViewportHeight();
  window.addEventListener('resize', setViewportHeight);
  window.addEventListener('orientationchange', setViewportHeight);
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)

